<template>
    <ul>
        <li v-for="contract in contracts">
            <router-link :to="`/contracts/view/${contract.id}`">{{ contract.writing_nbr ? contract.writing_nbr : 'View' }}</router-link> -&nbsp;

            {{ contract.seller_name }} @ {{ contract.product_level_commission ? contract.product_level_commission : contract.commission + ' (Legacy Commission Value)' }}

            <label class="badge badge-success" v-if="contract.is_active == 1">Active</label>
            <label class="badge badge-warning" v-else>Inactive</label>


            <template v-if="contract.downline && contract.downline.length > 0">
                <downline-list :contracts="contract.downline" />
            </template>
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
            contracts: {
                type: Array,
                required: true,
            }
        },

        data() {
            return {

            }
        },

        watch: {

        },

        computed: {

        },

        methods: {

        },

        mounted() {

        }
    }
</script>
